module.exports = __webpack_public_path__ + "static/media/UE-PL-Top-black.00214eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UE-PL-Top-black.svg
// module id = 242
// module chunks = 0